import React, {useState} from 'react';
import {ReactComponent as MoveIcon} from 'assets/svgs/actions/move.svg';
import {ReactComponent as DeleteIcon} from 'assets/svgs/actions/delete.svg';
import {ReactComponent as Duplicate} from 'assets/svgs/actions/duplicate.svg';
import {ReactComponent as ColourIcon} from 'assets/svgs/categories/colour.svg';
import {ReactComponent as EditIcon} from 'assets/svgs/common/check-black.svg';
import {ReactComponent as DownloadIcon} from 'assets/svgs/actions/download.svg';
import {ReactComponent as GroupIcon} from 'assets/svgs/company/groups.svg';
import {ReactComponent as StarIcon} from 'assets/svgs/common/star.svg';
import {Item, Menu} from 'react-contexify';

const colors = [
  '#f44336',
  '#e91e63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#2196f3',
  '#03a9f4',
  '#00bcd4',
  '#009688',
  '#4caf50',
  '#8bc34a',
  '#cddc39',
  '#ffeb3b',
  '#ffc107',
  '#ff9800',
  '#ff5722',
  '#795548',
  '#607d8b',
  '#37D67A',
  '#F47373',
];

const FileContextMenu = ({onClick, data, onHidden, selected}) => {
  const colorPlate = () => (
    <div className="color-container">
      {colors.map((c) => (
        <button
          className="btn-link"
          type="button"
          onClick={() => {
            setHovered(false);
            onClick({
              ...data,
              type: 'color',
              colour: c,
            });
          }}
          key={c}
          style={{background: c}}
        ></button>
      ))}
    </div>
  );

  const [hovered, setHovered] = useState(false);

  return (
    <Menu
      className="file-menu-class"
      id="FILEMENU"
      animation={null}
      onHidden={onHidden}
    >
      {data && (
        <>
          <Item
            disabled={data.isSpecial}
            onClick={() => {
              if (data.isSpecial) return;
              onClick({...data, type: 'copy'});
            }}
          >
            <Duplicate className="mr-2" />
            Duplicate
          </Item>

          <Item
            disabled={data.isSpecial || data.name === 'Chat'}
            onClick={() => {
              if (data.isSpecial) return;

              onClick({...data, type: 'move'});
            }}
          >
            <MoveIcon className="mr-2" />
            Move to
          </Item>
          <Item
            disabled={
              selected.length < 2 ||
              !selected.find((f) => f._id === data._id) ||
              data.isSpecial ||
              data.posts.length > 0
            }
            onClick={() => {
              if (
                selected.length < 2 ||
                !selected.find((f) => f._id === data._id) ||
                data.isSpecial ||
                data.posts.length > 0
              ) {
                return;
              }
              onClick({...data, type: 'group'});
            }}
          >
            <GroupIcon className="mr-2" />
            Group Files
          </Item>
          <Item
            onClick={() => {
              onClick({...data, type: 'star'});
            }}
            disabled={data.isSpecial}
          >
            <StarIcon className="mr-2" />
            Mark Star
          </Item>
          <Item
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <div className="d-flex color-item">
              <ColourIcon className="mr-2" />
              Change colour
              {hovered && colorPlate()}
            </div>
          </Item>
          <Item
            onClick={() => {
              if (data.name === 'Trash' || data.name === 'Chat') return;
              onClick({...data, type: 'rename'});
            }}
            disabled={data.name === 'Trash' || data.name === 'Chat'}
          >
            <EditIcon className="mr-2" />
            Rename
          </Item>
          <Item
            onClick={() => {
              if (data.isSpecial) return;
              onClick({...data, type: 'download'});
            }}
          >
            <DownloadIcon className="mr-2" />
            Download
          </Item>
          <Item
            disabled={data.isSpecial}
            onClick={() => {
              if (data.isSpecial) return;

              onClick({...data, type: 'delete'});
            }}
          >
            <DeleteIcon className="mr-2" />
            Delete
          </Item>
        </>
      )}
    </Menu>
  );
};

export default FileContextMenu;
